// extracted by mini-css-extract-plugin
export const contact = "contact-module--contact--2F6Sk";
export const labelName = "contact-module--label-name--3P79S";
export const inputName = "contact-module--input-name--BPGI_";
export const message = "contact-module--message--3qhp0";